import { FunctionComponent } from 'react';
import NextImage from 'next/image';
import { TypeImageComplete } from './types';

export const Image: FunctionComponent<TypeImageComplete> = ({ src, alt }) => (
  <div className="relative w-[58px] h-[51px]">
    <NextImage src={src} alt={alt ?? ''} fill className="object-cover" />
  </div>
);
